import { JSONEditor } from '@json-editor/json-editor'

const BaseEditor = JSONEditor.defaults.editors.uuid

// util function 
class UUIDEditor extends BaseEditor {
  // Normal behavior is that the Uuid is set to the default value in the prebuild function of this class
  // this breaks with the large-array editor type because that type is reusing the same form fields and repopulated them vs building new ones each time
  // so instead of using the uuid that was generated as the default value in the prebuild function, we generate it at the point in time the default value is requested
  getDefault () {
    return super.getUuid();
  }
}

export default UUIDEditor
